import script from "./notice-on-reporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./notice-on-reporting.vue?vue&type=script&lang=ts&setup=true"

import "./notice-on-reporting.vue?vue&type=style&index=0&id=20f481a8&scoped=true&lang=scss"
import "./notice-on-reporting.vue?vue&type=style&index=1&id=20f481a8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f481a8"]])

export default __exports__